import { lazyLoad } from "./LazyLoad";

/**
 * Make all container's images to be lazy loaded on the site.
 */
let initLazyLoadContainerImages = context => {
  const containers = context.querySelectorAll("[data-cms-container-lazy-load]");
  for (let i = 0, len = containers.length; i < len; i += 1) {
    lazyLoad(containers[i], target => {
      if (target.getAttribute("data-cms-src") !== null) {
        target.style.backgroundImage = `url(${target.getAttribute("data-cms-src")})`;
      }
    });
  }
};
const init = function () {
  initLazyLoadContainerImages(document);
};
export { initLazyLoadContainerImages, init };